// extracted by mini-css-extract-plugin
module.exports = {"labelListContainer":"BroadbandLabelList_labelListContainer__FZ1_a"};